export default __webpack_public_path__ + "static/media/suzuki-logo.4a9b44b3.png";